import React from 'react';

import { useTheme } from '@mui/material';

import './Spinner.scss';

const Spinner: React.FC = () => {
	const theme = useTheme();

	return (
		<div className="spinner-overlay" style={{ backgroundColor: `${theme.palette.background.default}d9` }}>
			<div className="spinner-wrapper">
				<div
					className="spinner-circle"
					style={{
						borderColor: theme.palette.primary.main,
						backgroundColor: theme.palette.background.paper,
					}}
				></div>
				<div className="spinner-image-mask">
					<img src="/assets/octopus.png" alt="Loading..." className="spinner-image" />
				</div>
			</div>
		</div>
	);
};

export default Spinner;
